import styled from 'styled-components';

export const DatepickerWithIconWrap = styled.div`
  position: relative;
  svg {
    position: absolute;
    right: 14px;
    top: 10px;
  }
`;
